'use strict';
module.exports = {
	footer_links: {
		items: [
			{title: 'Väder', url: '//www.svt.se/vader'},
			{title: 'TV-tablå', url: '//www.svt.se/tv-tabla/'},
			{title: 'Program A-Ö', url: '//www.svt.se/program/'},
			{title: 'Text-tv', url: '//www.svt.se/svttext/web/pages/100.html'},
			{title: 'Om SVT', url: '//www.svt.se/omsvt/'},
			{title: 'About SVT', url: '//www.svt.se/aboutsvt/'},
			{title: 'Tittarservice', url: '//www.svt.se/tittarservice/'},
			{title: 'Om Cookies', url: '//www.svt.se/tittarservice/hitta-svar/foretagetsvt/cookies-3'}
		]
	},
	footer_teasers: {
		items: [
			{title: 'SVT Play', url: '//www.svtplay.se'},
			{title: 'Barnkanalen', url: '//www.svt.se/barnkanalen'},
			{title: 'Bolibompa', url: '//www.svt.se/barnkanalen/bolibompa'},
			{title: 'SVT Nyheter', url: '//www.svt.se/nyheter'},
			{title: 'SVT Sport', url: '//www.svt.se/sport'},
			{title: 'Öppet arkiv', url: '//www.oppetarkiv.se'}
		]
	}
};



/** WEBPACK FOOTER **
 ** ./app/components/PageHandler/data/footerData.js
 **/